import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { InternalAvatar } from '../../internal';
import * as styles from './styles.module.css';

/**
 * Компонент аватарки
 *
 * Плейсхолдеры и скругления зависят от типа пользователя:
 * Люди - круглые
 * Компании - квадратные
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var DoubleAvatar = /*#__PURE__*/React.forwardRef(function DoubleAvatar(_ref, ref) {
  var primary = _ref.primary,
    secondary = _ref.secondary,
    size = _ref.size,
    highlight = _ref.highlight;
  return /*#__PURE__*/_jsxs("div", {
    ref: ref,
    className: styles['avatars'],
    style: {
      width: size,
      height: size
    },
    children: [/*#__PURE__*/_jsx(InternalAvatar, _objectSpread(_objectSpread({}, primary), {}, {
      className: styles['primary'],
      ref: ref,
      highlightWidth: 4,
      highlight: highlight,
      size: calcPrimarySize(size)
    })), /*#__PURE__*/_jsx(InternalAvatar, _objectSpread(_objectSpread({}, secondary), {}, {
      className: styles['secondary'],
      highlightWidth: 2,
      highlight: highlight,
      size: calcSecondarySize(size)
    }))]
  });
});
var PRIMARY_SIZE_RATIO = 88 / 94;
var SECONDARY_SIZE_RATIO = 32 / 94;
function calcPrimarySize(size) {
  return Math.round(size * PRIMARY_SIZE_RATIO / 4) * 4;
}
function calcSecondarySize(size) {
  return Math.round(size * SECONDARY_SIZE_RATIO / 4) * 4;
}